/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Nav_HomeInputs */

const en_footer_nav_home = /** @type {(inputs: Footer_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const tr_footer_nav_home = /** @type {(inputs: Footer_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anasayfa`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Footer_Nav_HomeInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const footer_nav_home = /** @type {((inputs?: Footer_Nav_HomeInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Nav_HomeInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_nav_home(inputs)
	return tr_footer_nav_home(inputs)
});